(function () {

    'use strict';

    angular
        .module('app.core')
        .service('CommonUtil', [
            'API_CONFIG',
            'APP_CONFIG',
            CommonUtil
        ]);

    function CommonUtil(API_CONFIG, APP_CONFIG) {
        var service = this;

        service.getPrivateLabelId = getPrivateLabelId;
        service.isUndefinedOrNull = isUndefinedOrNull;
        service.findById = findById;
        service.getLocationUrl = getLocationUrl;
        service.getDisplayLanguage = getDisplayLanguage;
        service.getDisplayLanguageFromCodeList = getDisplayLanguageFromCodeList;

        function getPrivateLabelId() {
            return API_CONFIG.PRIVATE_LABEL_ID;
        }

        function isUndefinedOrNull(obj) {
            return angular.isUndefined(obj) || obj === null;
        }

        function findById(array, idKey, idValue) {
            if (angular.isArray(array) && angular.isDefined(idKey) && angular.isDefined(idValue)) {
                for (var i = 0; i < array.length; i++) {
                    if (array[i][idKey] == idValue) {
                        return array[i];
                    }
                }
            }
            return undefined;
        }

        function getLocationUrl(location, displayLanguage, isUseLocationDefaultLanguage, noFrontHash) {
            var url = '#' + APP_CONFIG.HASH_PREFIX + '/';
            if (noFrontHash) {
                url = '';
            }
            if (angular.isDefined(location)) {
                url += 'loc/' + location.locationCode + '/';
                var languageCode = undefined;
                if (angular.isDefined(displayLanguage)) {
                    languageCode = displayLanguage.languageCode;
                }
                if (isUseLocationDefaultLanguage) {
                    languageCode = location.defaultLanguage;
                }
                if (angular.isDefined(languageCode)) {
                    url += 'lang/' + languageCode + '/';
                }
            }
            return url;
        }

        function getDisplayLanguageFromCodeList(languages, languageCodeList) {
            if (angular.isArray(languages) && angular.isArray(languageCodeList)) {
                var langCode;
                var language;
                for (var i = 0; i < languageCodeList.length; i++) {
                    langCode = languageCodeList[i];
                    language = getDisplayLanguage(languages, langCode);
                    if (angular.isDefined(language)) {
                        return language;
                    }
                }
            }
            return undefined;
        }

        function getDisplayLanguage(languages, languageCode) {
            if (angular.isDefined(languageCode)) {
                var language;
                var langCode = languageCode;
                while (langCode.length > 0) {
                    language = findById(languages, 'languageCode', langCode);
                    if (angular.isDefined(language)) {
                        return language;
                    }
                    langCode = langCode.substring(0, langCode.lastIndexOf('-'));
                }
            }
        }
    }

})();


// WEBPACK FOOTER //
// ./app/core/service/CommonUtil.js